import { render, staticRenderFns } from "./TripsHistory.vue?vue&type=template&id=36dd32fc&"
import script from "./TripsHistory.vue?vue&type=script&lang=js&"
export * from "./TripsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports